//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

(function() {
  const MIN_LENGTH = 4;
  const SUGGESTION_LIMIT = 5;

  const curalate = angular.module('curalate');

    /**
     * Emoji Typeahead
     *
     * Wrapper around the existing twitterTypeahead directive, providing suggestions for emojis based on the ':shortname:' format used on
     * slack/github/etc. Selected suggestions are replaced with their unicode equivalent.
     *
     * As there is currently no official standard for shortnames, we're using a mapping provided by emojione (stored in the 'emojiStrategy'
     * constant).
     *
     * Note: As the twitter-typeahead directive makes GA calls, a 'track-category' attribute is required on the input element, though it will not be
     * modified by this directive.
     *
     */
  curalate.directive('emojiTypeahead', [
    '$compile',
    'emojiStrategy',
    function(
            $compile,
            emojiStrategy,
        ) {
      return {
        restrict: 'A',
        require: '?ngModel',
        link(scope, elem, attrs, ngModel) {
          if (!ngModel) {
            return;
          }
          scope.typeahead = {
            context: {},
            events: {
              selected($event, selection) {
                ngModel.$setViewValue(selection.newQuery);
              },
            },
            templates: {
              suggestion: { html: require('@partials/emoji-typeahead-suggestion.html') },
            },
            key(result) {
              return result.newQuery;
            },
            searchEmoji: _.debounce((query, defer) => {
              const results = [];

              const matches = query.match(/\B:([-+\w]*)$/gi);

              if (!matches) {
                return defer.resolve([]);
              }

              const match = _.last(matches);

              if (match.length < MIN_LENGTH) {
                return defer.resolve([]);
              }

              _.each(emojiStrategy, (value, key) => {
                if (key.indexOf(match) > -1) {
                  results.push({
                    shortname: key,
                    unicode: value,
                  });
                }
              });

              results.sort((a, b) => (a.shortname.length > b.shortname.length));

              const newResults = _.chain(results)
                                .first(SUGGESTION_LIMIT)
                                .map(result => _.extend(result, { newQuery: ngModel.$viewValue.replace(new RegExp(`${match}$`), result.unicode) }))
                                .value();

              return defer.resolve(newResults);
            }, 200),
          };

          elem.removeAttr('emoji-typeahead');
          elem.addClass('emoji-typeahead');
          elem.attr('twitter-typeahead', '');
          elem.attr('templates', 'typeahead.templates');
          elem.attr('events', 'typeahead.events');
          elem.attr('get-data', 'typeahead.searchEmoji');
          elem.attr('key', 'typeahead.key');
          elem.attr('min-length', MIN_LENGTH);
          elem.attr('track-action-prefix', 'Emoji');
          $compile(elem)(scope);
        },
      };
    },
  ]);
})();
